import axios from 'axios'

export default {
    getJobs() {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/jobs').then((response) => {
            return response
        })
    },
    getJob(jobId) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/jobs/' + jobId).then((response) => {
            return response
        })
    },
    createJob(job) {
        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/jobs', job).then((response) => {
            return response
        })
    },
    editJob(job) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/jobs', job).then((response) => {
            return response
        })
    },
    deleteJob(jobId) {
        return axios.delete(process.env.VUE_APP_BACKEND_BASE_URL + '/jobs/' + jobId).then((response) => {
            return response
        })
    }
}
